import { Delete, Edit } from "@mui/icons-material";
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid2, IconButton, Paper, Typography } from "@mui/material";
import { useState } from "react";
import { Link } from "react-router-dom";
import { deleteQuestion } from "../services/main-questionnaire";
import { enqueueSnackbar } from "notistack";

const QuestionBox = ({
  question,
  getData
}) => {

  const [show_delete_dialog, set_show_delete_dialog] = useState(false);
  const [is_deleting, set_is_deleting] = useState(false);

  const handleDeleteQuestion = async () => {
    set_is_deleting(true);
    const { error } = await deleteQuestion({ id : question._id });
    set_is_deleting(false);

    if(error){
      enqueueSnackbar('Error while deleting question', {
        variant : 'error'
      })
    }else{
      getData();
      enqueueSnackbar('Question deleted successfully !', {
        variant : 'success'
      })
    }
  }

  return (
    <>
      <Paper
        sx={{
          padding: '20px',
          marginTop: '16px',
          display: 'flex',
          flexDirection: 'column',
          gap: '16px'
        }}
      >
        <Box
          display='flex'
          justifyContent='space-between'
          alignItems='center'
        >
          <Typography> Order : {question.question_order} </Typography>

          <Typography> Question Key : {question.question_key} </Typography>

          <Box
            display='flex'
            gap='4px'
          >
            <Link
              to={`/main-questionnaire/edit/${question._id}`}
            >
              <IconButton
                size="small"
              >
                <Edit />
              </IconButton>
            </Link>

            <IconButton
              size="small"
              color="error"
              onClick={() => set_show_delete_dialog(true)}
            >
              <Delete />
            </IconButton>
          </Box>

        </Box>

        <Typography> Question : {question.title} </Typography>

        <Typography> Next Page Question : {question.next_page_question} </Typography>

        <Typography> Options : </Typography>

        <Grid2
          container
          spacing={3}
        >
          {
            question.options.map((option, option_index) => {

              const option_key = `${question._id}-option-${option_index}`;

              return (
                <Grid2
                  size={4}
                  key={option_key}
                >
                  <Box
                    border='1px solid #ccc'
                    borderRadius='4px'
                    padding='8px'
                    display='flex'
                    flexDirection='column'
                    gap='8px'
                  >
                    <Typography variant="body2">
                      {option.title}
                    </Typography>
                    <Typography variant="body2">
                      Order : {option.option_order}
                    </Typography>

                    {
                      option.modalities.map((modality, modality_index) => {

                        const modality_key = `${option_key}-modality-${modality_index}`
                        const healer_names = modality.healers.map((healer) => healer.name);

                        return (
                          <Box
                            border='1px solid #ccc'
                            borderRadius='4px'
                            padding='8px'
                            display='flex'
                            flexDirection='column'
                            gap='8px'
                            key={modality_key}
                          >
                            <table>
                              <tbody>
                                <tr>
                                  <td width={60}>
                                    <Typography variant="body2"> Modality </Typography>
                                  </td>
                                  <td width={10}>
                                    <Typography variant="body2"> : </Typography>
                                  </td>
                                  <td>
                                    <Typography variant="body2"> {modality.modality} </Typography>
                                  </td>
                                </tr>
                                <tr>
                                  <td width={60}>
                                    <Typography variant="body2"> Healers </Typography>
                                  </td>
                                  <td width={10}>
                                    <Typography variant="body2"> : </Typography>
                                  </td>
                                  <td>
                                    <Typography variant="body2"> {healer_names.join(', ')} </Typography>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </Box>
                        )
                      })
                    }
                  </Box>
                </Grid2>
              )
            })
          }
        </Grid2>
      </Paper>

      <Dialog
        open={show_delete_dialog}
      >
        <DialogTitle>
          Are you sure you want to delete this question ?
        </DialogTitle>

        <DialogContent>
          {question.title}
        </DialogContent>

        <DialogActions>
          <Button
            variant="outlined"
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            disabled={is_deleting}
            onClick={handleDeleteQuestion}
          >
            { is_deleting ? 'Deleting' : 'Yes, Delete' }
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default QuestionBox;